export default function notificationsReducer(state = [], action) {
   const { type, notificationsData } = action
   switch (type) {
      case 'SET_ALL_NOTIFICATIONS_LIST':
         return notificationsData
      default:
         return state
   }
}
